import { jsxs, jsx } from "react/jsx-runtime";
import { useRef, useCallback } from "react";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { useTheme, Box } from "@mui/material";
import { InsetIcon } from "../Icons/index.es.js";
import stitches from "../theme.config.es.js";
import EzListBox from "./EzListBox.es.js";
import EzTextInput from "./EzTextInput.es.js";
import { TextInputWrapper } from "./Picker.styles.es.js";
import { useSelectState, useSelect } from "./useSelect.es.js";
import { domProps } from "../../utils/domProps.es.js";
import EzIcon from "../EzIcon/EzIcon.es.js";
import EzPopover from "../EzPopover/EzPopover.es.js";
const pointer = stitches.css({ cursor: "default" });
const createChangeEvent = () => {
  if (typeof CustomEvent === "function") return new CustomEvent("change");
  const evt = document.createEvent("HTMLEvents");
  evt.initEvent("change", false, true);
  return evt;
};
const popper = stitches.css({
  zIndex: "$select-z"
  // this is hard-coded in theme.config.ts for now, but we should really pull it in from mui when we convert select to mui
});
const iconWrapperStyle = stitches.css({
  alignItems: "center",
  display: "flex",
  fontSize: "13px"
});
const EzSelect = (props) => {
  const emotionTheme = useTheme();
  const { onChange } = props;
  const triggerRef = useRef();
  const listboxRef = useRef();
  const ariaLabelledBy = props["aria-labelledby"];
  const containerRef = useRef();
  const changeEvent = useCallback(
    (optionValue) => {
      const event = createChangeEvent();
      containerRef.current.value = optionValue;
      containerRef.current.dispatchEvent(event);
      return event;
    },
    [containerRef]
  );
  const state = useSelectState({
    ...props,
    onSelectionChange(value) {
      var _a;
      onChange == null ? void 0 : onChange(changeEvent(value));
      (_a = props.onSelectionChange) == null ? void 0 : _a.call(props, value);
    }
  });
  const { inputProps, listBoxProps } = useSelect(
    {
      ...props,
      triggerRef,
      popoverRef: listboxRef
    },
    state
  );
  return /* @__PURE__ */ jsxs(Box, { className: "EzSelect", color: emotionTheme.tokens["color-text-default"], ref: containerRef, children: [
    /* @__PURE__ */ jsxs(TextInputWrapper, { className: props.className || "", disabled: props.disabled, children: [
      /* @__PURE__ */ jsx(
        EzTextInput,
        {
          ...domProps(inputProps, pointer()),
          ref: triggerRef,
          error: props.error,
          touched: props.touched
        }
      ),
      /* @__PURE__ */ jsx(InsetIcon, { insetY0: true, right0: true, pr2: true, children: /* @__PURE__ */ jsx("div", { className: iconWrapperStyle(), children: /* @__PURE__ */ jsx(EzIcon, { icon: state.isOpen ? faChevronUp : faChevronDown, size: "inherit" }) }) })
    ] }),
    state.isOpen && /* @__PURE__ */ jsx(
      EzPopover,
      {
        shouldCloseOnBlur: true,
        onClose: state.close,
        targetRef: triggerRef,
        placement: "bottom-start",
        matchWidth: true,
        className: popper(),
        classNameSuffix: props.classNameSuffix,
        children: /* @__PURE__ */ jsx(
          EzListBox,
          {
            ...listBoxProps,
            "aria-labelledby": [ariaLabelledBy, props.id].join(" "),
            ref: listboxRef,
            onClick: () => triggerRef.current.focus(),
            collection: state.collection,
            selectionManager: state.selectionManager,
            focusLabel: props.focusLabel
          }
        )
      }
    )
  ] });
};
export {
  EzSelect as default
};
//# sourceMappingURL=EzSelect.es.js.map
